module.exports = __webpack_public_path__ + "img/time.a9288f52.png";